// extracted by mini-css-extract-plugin
export default {"alphaBadge":"AlphaIndicator_alphaBadge__n3sd9"};